<template>
	<money-field
		@change="change"
		@enter="keypressEnter"
		@tab="keypressTab"
		@icon-clicked="iconClicked"
		@focus="focus"
		@blur="blur"
		v-model="temp_value"
		:id="id"
		:name="name"
		:placeholder="placeholder"
		:currency="currency"
		:separator="separator"
		:minus="minus"
		:clear-zero="clearZero"
		:precision="precision"
		:static-precision="actual_precision"
		:label="label"
		:prefix="prefix"
		:suffix="suffix"
		:help="help"
		:error="error"
		:tabindex="tabindex"
		:prevent-enter="preventEnter"
		:asterisk="asterisk"
		:required="required"
		:disabled="disabled"
		:readonly="readonly"
		:autofocus="autofocus"
		:autocomplete="autocomplete"
		:text-direction="textDirection"
		:container-text-direction="containerTextDirection"
		:min="min"
		:max="max"
		:empty-value="emptyValue"
		:icon="icon"
		:has-error="hasError"
		:has-success="hasSuccess"
		:is-loading="isLoading"
		:is-full="isFull"
		:extra-classes="extraClasses"
		:container-classes="containerClasses"
		:width="width"
		:size="size"
	></money-field>
</template>

<script type="text/babel">
export default {
	props: {
		id: { default: "" },
		name: { default: "" },
		value: { default: 0.0 },
		placeholder: { default: "" },

		currency: { default: null },
		separator: { default: "." },
		minus: { default: true },
		clearZero: { default: true },
		precision: { default: 3 },
		staticPrecision: { default: null },

		label: { default: "" },
		prefix: { default: "" },
		suffix: { default: "" },
		help: { default: "" },
		error: { default: false },
		tabindex: { default: null },

		preventEnter: { default: false },
		asterisk: { default: false },
		required: { default: false },
		disabled: { default: false },
		readonly: { default: false },
		autofocus: { default: false },
		autocomplete: { default: "off" }, // on/off
		textDirection: { default: "right" }, // left,center,right
		containerTextDirection: { default: "left" }, // left,center,right

		max: { default: 100.0 },
		min: { default: 0.0 },
		emptyValue: {
			default: 0,
		},

		icon: { default: null },

		hasError: { default: false },
		hasSuccess: { default: false },
		isLoading: { default: false },
		isFull: { default: false },

		extraClasses: { default: "" },
		containerClasses: { default: "" },
		width: { default: null },
		size: { default: "regular" }, // regular, large
	},

	data: function () {
		return {
			temp_value: 0,
			override_precision: null,
		};
	},

	watch: {
		value: function (value) {
			this.temp_value = value !== null ? value : "";
		},

		temp_value: function (value) {
			this.$emit("input", value);
		},
	},

	methods: {
		keypressEnter(e) {
			this.$emit("keypress.enter", e);
			this.$emit("enter", e);
		},

		keypressTab(e) {
			this.$emit("tab", e);
		},

		change(e) {
			this.$emit("change", e);
		},

		iconClicked(e) {
			this.$emit("icon-clicked", e);
		},

		focus() {
			this.$emit("focus");
		},

		blur() {
			this.$emit("blur");
		},
	},

	computed: {
		actual_precision() {
			if (this.staticPrecision !== null) {
				return parseInt(this.staticPrecision);
			}

			if (this.override_precision) {
				return parseInt(this.override_precision);
			}

			return parseInt(this.precision);
		},
	},

	mounted() {
		this.temp_value =
			this.value !== null ? (typeof this.value === "number" ? this.value : window.vat_format(this.value)) : "";

		this.override_precision = window.user_account.settings.system.price_decimals;

		if (this.override_precision > 3) {
			this.override_precision = 3;
		}
	},
};
</script>
